import { render, staticRenderFns } from "./PowerStation.vue?vue&type=template&id=304a39dc&scoped=true&"
import script from "./PowerStation.vue?vue&type=script&lang=js&"
export * from "./PowerStation.vue?vue&type=script&lang=js&"
import style0 from "./PowerStation.vue?vue&type=style&index=0&id=304a39dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304a39dc",
  null
  
)

export default component.exports